<template>
  <div class="bindPage rightPage">
    <div class="layout">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @confirmFn="getListFn"
        @searchFn="getListFn"
        @addFn="addFn"
        @delFn="delFn"
        @editScopeFn="editScopeFn"
        @dataImFn="dataImFn"
        @netFn="netFn"
      />
      <div class="componentPage">
        <STable
          :columns="columns"
          :req="relayList"
          :params="[SearchForm, 'unknown']"
          ref="stable"
          @selectData="choozeTable"
        ></STable>
      </div>
    </div>

    <!-- 修改范围 -->
    <EditScope
      :isShowEditShow.sync="isShowEditShow"
      :scopeArray="scopeArray"
      ref="scopedId"
    />
    <!-- 新增&&编辑 -->
    <AddEdit
      :isShow.sync="isShow"
      :title="title"
      :scopeArray="scopeArray"
      :editRow="editRow"
      ref="vForm"
      v-bind="$attrs"
    />
    <!-- 上传 -->
    <importDialog :isShowImDialog.sync="isShowImDialog" ref="importDia" />
    <!-- 网络参数 -->
    <Net
      :isShow.sync="isNetShow"
      :title="title"
      :choozeTableData="choozeTableData"
      ref="net"
    />
    <!-- 配置信息 -->
    <Config
      :isShowConfig.sync="isShowConfig"
      :title="title"
      :rowData="rowData"
      v-bind="$attrs"
      ref="config"
      v-if="isShowConfig"
    />
  </div>
</template>

<script>
import getAllTreePath from '@/utils/getAllTreePath.js'
import bus from '@/utils/bus.js'
import DetailDialog from '../components/DetailDialog.vue'
import AddEdit from '../components/AddEditDialog.vue'
import EditScope from '../components/EditScope.vue'
import importDialog from '../components/gatewayIm.vue'
import Net from '../components/VNet.vue'
import Config from '../components/ConfigDialog.vue'

import { shareScope } from '@/api/modules/public.js'
import { relayDel, relayDetailInfo, relayList } from '@/api/modules/relay.js'
import STable from '@/components/STable/STable.vue'
import columns, { searchCondi } from '../config/unknownTable'
import { getIsPlatform } from '@/utils/permission'

export default {
  mixins: [getAllTreePath],
  components: {
    DetailDialog,
    AddEdit,
    EditScope,
    importDialog,
    Net,
    Config,
    STable
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newval) {
        this.formContent[1].selectParam = newval
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if (
        (!currentUser.sysScope && currentUser.scopeAdmin) ||
        currentUser.type === 2
      ) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    },
    columns () {
      return columns.call(this)
    },
    relayList: () => relayList
  },
  data () {
    return {
      formContent: searchCondi,
      SearchForm: {
        scopeName: null,
        name: null,
        type: null,
        mac: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 3,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.tbopt_delete',
          method: 'delFn'
        },
        // {
        //   id: 4,
        //   icon: '',
        //   vHas: ['incubatorAddCarrier'],
        //   text: 'public.net_param',
        //   method: 'netFn'
        // },
        // {
        //   id: 5,
        //   icon: '',
        //   vHas: ["incubatorAddCarrier"],
        //   text: $t('integration.form_template'),
        //   method: 'tableTelFn'
        // },
        {
          id: 6,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'device.import_data',
          method: 'dataImFn'
        }
      ],
      choozeTableData: [],
      title: '',
      // 修改范围
      isShowEditShow: false,
      detailObj: {},
      netObj: {},
      // 新增&&编辑
      isShow: false,
      scopeArray: [],
      editRow: {},
      // 上传
      isShowImDialog: false,
      // 网络参数
      isNetShow: false,
      rowData: {},
      isShowConfig: false
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      this.treeClickSearchFn(row)
    })
    if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
      this.optareBtn.push({
        id: 2,
        icon: '',
        vHas: ['incubatorAddCarrier'],
        text: 'device.modify_customer',
        method: 'editScopeFn'
      })
    }
    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
  },
  methods: {
    /** 分页 */
    getListFn () {
      this.$refs.stable.getList()
    },
    /** 点击树形查询 */
    treeClickSearchFn (row) {
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        scopeName: null,
        name: null,
        type: null,
        mac: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }
      bus.$emit('initTree')
      this.getListFn()
    },
    choozeTable (row) {
      this.choozeTableData = row
    },
    /** 获取范围 */
    getSence () {
      if (this.scopeArray.length > 0) return
      shareScope({ tab: 1 }).then(res => {
        if (res.state.code == 200) {
          this.scopeArray = res.result.filter(item => {
            return item.id > 0
          })
        }
      })
    },
    /** 新增 */
    addFn () {
      this.isShow = true
      this.title = $t('integration.add_relay')
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        this.$refs.vForm.dioForm.id = null
      })
    },
    /** 修改范围 */
    editScopeFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const flag = this.distinguishTypeFn('scene_id')
      if (!flag) {
        return this.$message.error($t('请选择同一客户'))
      }
      this.isShowEditShow = true
      this.getSence()
      this.$nextTick(() => {
        this.$refs.scopedId.dioForm.sceneId =
          this.choozeTableData[0].scene_id + ''
        this.$refs.scopedId.dioForm.ids = this.choozeTableData
          .map(item => item.id)
          .join(',')
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam[str] !== item[str]) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },
    /** 单条编辑 */
    editRowFn (row) {
      this.isShow = true
      this.title = `编辑中继[${row.relayCode}]`
      this.getSence()
      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
      })
      relayDetailInfo(row.id).then(({ result }) => {
        this.editRow = Object.assign(
          {},
          { ...result.netConfig },
          { ...result.relay }
        )
      })
    },
    /** 多条删除 */
    delFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          const idList = this.choozeTableData.map(item => item.id)
          const query = {
            ids: idList.join(','),
            edited: 2
          }

          relayDel(query).then(async ({ state }) => {
            await this.$resultHandle(state)

            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条删除 */
    delRowFn (row) {
      const query = {
        ids: row.id,
        edited: 2
      }
      relayDel(query).then(async ({ state }) => {
        await this.$resultHandle(state)

        this.getListFn()
      })
    },
    /** 详情 */
    detailFn (row) {
      bus.$emit('relayParam', row.id, row.relayCode)
    },

    // /** 表格模板 */
    // tableTelFn() {

    //   getGeneraUploadTemplateFile('relay', this.$i18n.locale).then((res) => {
    //     if (res) {
    //       this.$message.success($t('integration.download_successful'))
    //     }
    //   })
    // },
    /** 网络参数弹出框 */
    netFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isNetShow = true
      this.title = this.$t('device.add_net_param')
      this.$nextTick(() => {
        this.$refs.net.clearValidate()
      })
    },
    // 数据导入
    dataImFn () {
      this.isShowImDialog = true
      this.$nextTick(() => {
        if (this.$refs.importDia.$refs.refFile) {
          this.$refs.importDia.$refs.refFile.clearFiles()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bindPage {
  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  .componentPage {
    flex: 1;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
